import { render } from "./Learn.vue?vue&type=template&id=d6b6d364&scoped=true&lang=pug"
import script from "./Learn.vue?vue&type=script&lang=js"
export * from "./Learn.vue?vue&type=script&lang=js"

import exportComponent from "/Users/redbot/nodeApps/thinkhub-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6b6d364"]])

export default __exports__